/* ============================================================
   Quiz Ritmoculto — quiz.js
   ============================================================ */
(function () {
  'use strict';

  const QUIZ_QUESTIONS = 50;
  const COUPON_STORAGE_KEY = 'ritmoculto_quiz_coupon';

  const RANKS = [
    { min: 0,  max: 10, name: 'Turista Sonoro',  desc: 'Sabes que la música existe. Buen comienzo.' },
    { min: 11, max: 20, name: 'Oyente Casual',    desc: 'Le das play y ya, mientras la canción sea buena, todo bien.' },
    { min: 21, max: 30, name: 'Seguidor',         desc: 'Sigues a tus artistas más allá del hit que suena en todos lados.' },
    { min: 31, max: 40, name: 'Fan',              desc: 'Te sabes los coros y defiendes a tu artista en los comentarios.' },
    { min: 41, max: 50, name: 'Conocedor',        desc: 'Tienes data que ni tus amigos te pidieron.' },
    { min: 51, max: 60, name: 'Digger',           desc: 'Buscas en los créditos quién tocó qué. Nivel detective.' },
    { min: 61, max: 70, name: 'Melómano',         desc: 'Tu playlist es mejor curada que una galería de arte.' },
    { min: 71, max: 80, name: 'Archivero',        desc: 'Sabes discografías completas de memoria, hasta los lados B.' },
    { min: 81, max: 90, name: 'Enciclopedia',     desc: 'La gente te pregunta a ti antes que a Google.' },
    { min: 91, max: 100, name: 'Leyenda',         desc: 'Naciste escuchando vinilos en el vientre materno.' }
  ];

  let allQuestions = [];
  let activeQuestions = [];
  let currentIndex = 0;
  let score = 0;
  let answered = false;
  let muted = false;

  const $ = (id) => document.getElementById(id);

  function hideAll() {
    ['quiz-start','quiz-suggest-form','quiz-question','quiz-result'].forEach(id => {
      const el = $(id);
      if (el) el.classList.add('quiz-hidden');
    });
  }

  function show(el) { if (el) el.classList.remove('quiz-hidden'); }
  function hide(el) { if (el) el.classList.add('quiz-hidden'); }

  function loadData() {
    try {
      const raw = JSON.parse($('quiz-data').textContent);
      allQuestions = (raw.questions || []).map(q => ({
        question: q.question,
        correct: q.correct,
        wrong: typeof q.wrong === 'string' ? JSON.parse(q.wrong) : (q.wrong || [])
      }));
    } catch (e) {
      console.error('Quiz: error preguntas', e);
    }
  }

  function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function getScorePct() { return Math.round((score / activeQuestions.length) * 100); }

  function getRank(pct) {
    for (const r of RANKS) {
      if (pct >= r.min && pct <= r.max) return r;
    }
    return null;
  }

  function playSound(correct) {
    try {
      if (muted) return;
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      if (correct) {
        osc.type = 'triangle';
        osc.frequency.setValueAtTime(523, ctx.currentTime);
        osc.frequency.setValueAtTime(659, ctx.currentTime + 0.1);
        osc.frequency.setValueAtTime(784, ctx.currentTime + 0.2);
        gain.gain.setValueAtTime(0.3, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
        osc.start(ctx.currentTime);
        osc.stop(ctx.currentTime + 0.5);
      } else {
        osc.type = 'sawtooth';
        osc.frequency.setValueAtTime(200, ctx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(80, ctx.currentTime + 0.3);
        gain.gain.setValueAtTime(0.3, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
        osc.start(ctx.currentTime);
        osc.stop(ctx.currentTime + 0.4);
      }
    } catch (e) {}
  }

  function goToStart() {
    hideAll();
    const couponEl = $('quiz-result-coupon');
    if (couponEl) { couponEl.innerHTML = ''; hide(couponEl); }
    hide($('quiz-result-cta'));
    show($('quiz-start'));
  }

  function startQuiz() {
    if (allQuestions.length === 0) { alert('No hay preguntas disponibles.'); return; }
    const pool = shuffle(allQuestions);
    activeQuestions = pool.slice(0, Math.min(QUIZ_QUESTIONS, pool.length));
    currentIndex = 0;
    score = 0;
    hideAll();
    show($('quiz-question'));
    buildCircles();
    showQuestion();
  }

  function buildCircles() {
    const el = $('quiz-progress-circles');
    el.innerHTML = '';
    for (let i = 0; i < activeQuestions.length; i++) {
      const c = document.createElement('span');
      c.className = 'quiz-circle';
      c.dataset.index = i;
      el.appendChild(c);
    }
  }

  function fillCircle(index, correct) {
    const c = $('quiz-progress-circles').querySelector(`[data-index="${index}"]`);
    if (c) c.classList.add(correct ? 'quiz-circle--correct' : 'quiz-circle--wrong');
  }

  function showQuestion() {
    answered = false;
    $('quiz-btn-next').disabled = true;
    const q = activeQuestions[currentIndex];
    $('quiz-question-text').textContent = q.question;
    const options = shuffle([q.correct, ...q.wrong]);
    const optionsEl = $('quiz-options');
    optionsEl.innerHTML = '';
    options.forEach((opt) => {
      const btn = document.createElement('button');
      btn.className = 'quiz-option';
      btn.textContent = opt;
      btn.addEventListener('click', () => selectOption(btn, opt, q.correct));
      optionsEl.appendChild(btn);
    });
    $('quiz-btn-next').textContent =
      currentIndex === activeQuestions.length - 1 ? 'Ver resultado' : 'Siguiente';
  }

  function selectOption(btn, selected, correct) {
    if (answered) return;
    answered = true;
    const isCorrect = selected === correct;
    if (isCorrect) score++;
    $('quiz-options').querySelectorAll('.quiz-option').forEach((b) => {
      b.disabled = true;
      if (b.textContent === correct) b.classList.add('quiz-option--correct');
      else if (b === btn && !isCorrect) b.classList.add('quiz-option--wrong');
    });
    fillCircle(currentIndex, isCorrect);
    playSound(isCorrect);
    $('quiz-btn-next').disabled = false;
  }

  function nextQuestion() {
    currentIndex++;
    if (currentIndex >= activeQuestions.length) showResult();
    else showQuestion();
  }

  function showResult() {
    hideAll();
    show($('quiz-result'));
    const pct = getScorePct();
    const rankObj = getRank(pct);

    $('quiz-result-score').textContent = `${score} / ${activeQuestions.length}`;
    $('quiz-result-pct').textContent = `${pct}%`;
    $('quiz-result-label').textContent = 'de respuestas correctas en el Quiz Bandas & Artistas';

    const rankEl = $('quiz-result-rank');
    if (rankObj) {
      rankEl.innerHTML = `Tu nivel es: <strong>${rankObj.name}</strong><br><span class="quiz-rank-desc">${rankObj.desc}</span>`;
    } else {
      rankEl.textContent = '';
    }

    buildShareButtons(pct, rankObj ? rankObj.name : '');
  }

  function buildShareButtons(pct, rankName) {
  const shareEl = $('quiz-share-buttons');
  if (!shareEl) return;
  const text = `Obtuve ${pct}% en el Quiz Bandas & Artistas de Ritmoculto${rankName ? ` — Nivel: ${rankName}` : ''}`;
  const url = 'https://ritmoculto.cl/pages/quiz';

  shareEl.innerHTML = `
    <button class="quiz-share-btn quiz-share-native" id="quiz-share-native">Compartir 🔗</button>
    <button class="quiz-share-btn quiz-share-dl" id="quiz-download-card">Descargar imagen ⬇</button>
  `;

  $('quiz-share-native').addEventListener('click', () => {
    if (navigator.share) {
      navigator.share({ title: 'Quiz Ritmoculto', text: text, url: url });
    } else {
      navigator.clipboard.writeText(url).then(() => {
        $('quiz-share-native').textContent = '¡Link copiado!';
        setTimeout(() => { $('quiz-share-native').textContent = 'Compartir 🔗'; }, 2000);
      });
    }
  });

  $('quiz-download-card').addEventListener('click', () => {
    const canvas = $('quiz-card-canvas');
    const card_bg = '#1a1a1a';
    const font = 'sans-serif';
    const ctx = canvas.getContext('2d');
    const W = canvas.width;
    const H = canvas.height;

    ctx.fillStyle = card_bg;
    ctx.fillRect(0, 0, W, H);
    ctx.textAlign = 'center';

    ctx.font = `700 18px ${font}`;
    ctx.fillStyle = 'rgba(255,255,255,0.7)';
    ctx.fillText(`${score} / ${activeQuestions.length}`, W / 2, 45);

    ctx.font = `700 16px ${font}`;
    ctx.fillStyle = 'rgba(255,255,255,0.7)';
    ctx.fillText('Has obtenido', W / 2, 80);

    ctx.font = `bold 80px ${font}`;
    ctx.fillStyle = '#ffffff';
    ctx.fillText(`${pct}%`, W / 2, 175);

    ctx.font = `700 15px ${font}`;
    ctx.fillStyle = 'rgba(255,255,255,0.7)';
    ctx.fillText('de respuestas correctas en el Quiz Bandas & Artistas', W / 2, 210);

    if (rankName) {
      ctx.font = `700 15px ${font}`;
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText('Tu nivel es:', W / 2, 238);
      ctx.font = `bold 22px ${font}`;
      ctx.fillStyle = '#ffffff';
      ctx.fillText(rankName, W / 2, 265);
    }

    ctx.font = `400 12px ${font}`;
    ctx.fillStyle = 'rgba(255,255,255,0.35)';
    ctx.fillText('ritmoculto.cl/pages/quiz', W / 2, H - 12);

    const a = document.createElement('a');
    a.download = 'quiz-ritmoculto.png';
    a.href = canvas.toDataURL('image/png');
    a.click();
  });
}


  function init() {
    loadData();
    $('quiz-btn-start').addEventListener('click', startQuiz);
    $('quiz-btn-next').addEventListener('click', nextQuestion);
    $('quiz-btn-restart').addEventListener('click', goToStart);
    $('quiz-btn-reset').addEventListener('click', goToStart);
    $('quiz-btn-mute').addEventListener('click', () => {
      muted = !muted;
      $('quiz-btn-mute').textContent = muted ? '🔇' : '🔊';
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
